import { Navigate, Outlet, useParams } from 'react-router';
import { useFlags } from '@repo/poly-hooks/flags';

export function KycGuard() {
  const { featureBooleanUseNewKycModules } = useFlags();
  const { registration_id: registrationId } = useParams<{ registration_id: string }>();

  if (!featureBooleanUseNewKycModules) {
    return <Navigate replace to={`/registrations/${registrationId}/kyc`} />;
  }

  return <Outlet />;
}
